import React, { ReactElement } from "react";
import { StepProps } from "../TradeModal";
import { useQueryBundle } from "source/hooks";
import LoadingBlock from "components/Loading/LoadingBlock";
import { GetOauthUrlForBroker } from "$gql/queries/tradier/GetOauthUrlForBroker.gen";
import { OAuthUrlBundle } from "$gql/types.gen";
import Cookies from "js-cookie";
import { brokerDetailMapping } from "components/BrokerConnectionMessage/BrokerConnectionMessage";
import Button from "components/core/Button/Button";

export default function RetreiveOauthUrl(props: StepProps): ReactElement {
  props.setTitle(`Connecting to ${props.state.brokerName}`);

  const brokerPopupUrlQuery = useQueryBundle(GetOauthUrlForBroker, {
    variables: {
      stockSymbol: props.state.tickerSymbol,
      institutionLoginId: props.state.institutionLoginId ?? 0,
      institutionAccountId: props.state.institutionAccountId,
      redirectUrl: `${props.state.baseUrl}?institutionAccountId=${props.state.institutionAccountId}`,
    },
  });

  if (brokerPopupUrlQuery.state !== "DONE") {
    return <LoadingBlock />;
  }

  const oauthUrlBundle =
    brokerPopupUrlQuery.data.trading.getOAuthUrlForExistingLogin;

  if (!oauthUrlBundle) {
    throw new Error("No url found");
  }

  const navigateToOAuth = (bundle: OAuthUrlBundle) => {
    console.log(bundle);

    Cookies.set("oAuthState", bundle.state);
    window.location.href = bundle.url;
  };

  const brokerName = brokerDetailMapping[props.state.brokerName || ""].name;

  return (
    <div>
      <p>
        You are about to be transferred to {brokerName} in order to authenticate
        your account. Note, we do not store any credentials, and {brokerName} is
        in full control of how we access your account.
      </p>
      <Button
        data-cy="connect-account-confirmation"
        onClick={() => navigateToOAuth(oauthUrlBundle)}
      >
        Connect Account
      </Button>
    </div>
  );
}
